import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { IconButton } from '../../IconButton';
import { TextButton } from '../../TextButton';
import { PRIMARY_ACTION_ICON_SIZE } from '../tableCore/table.constants';
export function renderRowAction(param) {
    let { action, withLabel, testId } = param;
    if (action == null) return undefined;
    if (withLabel) {
        if (action.disabled === true || action.hiddenOnMobile === true) return undefined;
        return /*#__PURE__*/ _jsx(TextButton, {
            bi: action.bi,
            skin: "primary",
            underline: "none",
            disabled: action.disabled,
            intent: action.intent,
            prefixIcon: /*#__PURE__*/ _jsx(action.icon, {
                size: PRIMARY_ACTION_ICON_SIZE
            }),
            onClick: action.onClick,
            testId: testId,
            children: action.title
        });
    }
    return /*#__PURE__*/ _jsx(IconButton, {
        bi: action.bi,
        skin: "primaryTransparent",
        size: "small",
        noPadding: true,
        disabled: action.disabled,
        intent: action.intent,
        tooltip: {
            placement: 'top',
            title: action.title
        },
        onClick: action.onClick,
        testId: testId,
        children: /*#__PURE__*/ _jsx(action.icon, {
            size: PRIMARY_ACTION_ICON_SIZE
        })
    });
}
export function toRenderRows(param) {
    let { items, getRowId } = param;
    return items.flatMap((row, index)=>{
        var _ref, _row_subItems;
        const rowId = (_ref = getRowId === null || getRowId === void 0 ? void 0 : getRowId(row, index)) !== null && _ref !== void 0 ? _ref : index;
        const children = (_row_subItems = row.subItems) !== null && _row_subItems !== void 0 ? _row_subItems : [];
        return [
            {
                row,
                rowId,
                nested: false
            },
            ...children.map((child, childIndex)=>{
                var _ref;
                return {
                    row: child,
                    rowId: (_ref = getRowId === null || getRowId === void 0 ? void 0 : getRowId(child, childIndex)) !== null && _ref !== void 0 ? _ref : "".concat(rowId, "-nested-").concat(childIndex),
                    nested: true
                };
            })
        ];
    });
}
